import cn from "classnames";
import type { FC } from "react";
import type { BorderDashType } from "../../types";
import styles from "./BorderMenu.module.css";

interface BorderTypeButtonProps {
    borderType: BorderDashType;
    selectedBorderType: BorderDashType;
    onClick: (borderType: BorderDashType) => void;
    Icon: FC;
}

export function BorderTypeButton({
    borderType,
    selectedBorderType,
    onClick,
    Icon,
}: BorderTypeButtonProps) {
    const handleClick = () => {
        onClick(borderType);
    };

    const buttonStyles = cn(
        styles.typeButton,
        selectedBorderType === borderType && styles.selected,
    );

    return (
        <button className={buttonStyles} type="button" onClick={handleClick}>
            <Icon />
        </button>
    );
}
